import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ "name" ]

  greet() {
    const element = this.nameTarget
    const name = element.value
    console.log(`Hello, ${name}!`)
  }
}



// WEBPACK FOOTER //
// app/javascript/packs/controllers/hello_controller.js